export enum ReduxErrorUiOption {
  Dialog,
  ErrorPage
}
export class ReduxError {
  source: string;
  url?: string;
  silent?: boolean;
  mustResolve?: boolean;
  uiOption?: ReduxErrorUiOption;
  maxValidationErrors?: number;
}
